(() => {
  function init() {
    const root = document.querySelector('.js-product-8745937830039');
    const tabs = root?.querySelector('#togstd-product-tabs');
    const panel = tabs?.querySelector('#togstd-description-panel');
    if (!panel || tabs.dataset.fanReady) return;
    tabs.dataset.fanReady = 'true';
    tabs.classList.add('za-fan-tabs');
    const primaryImage = root.querySelector('.product-single__photos img');
    if (primaryImage) { primaryImage.loading = 'eager'; primaryImage.fetchPriority = 'high'; }
    if(panel.hasAttribute('data-za-backend-content'))return;
    const images = JSON.parse(document.getElementById('za-clip-fan-images').textContent);
    const make = (tag, cls, html) => { const el = document.createElement(tag); el.className = cls; if (html) el.innerHTML = html; return el; };
    const picture = (index, alt) => {
      const image = make('img', 'zf-image');
      const source = images[index] || images[0];
      image.src = typeof source === 'string' ? source : source.src;
      image.alt = alt; image.width = 640; image.height = 640; image.loading = 'lazy';
      return image;
    };
    const sections = [...panel.querySelectorAll(':scope > .togstd-section')];
    const findSection = text => sections.find(s => s.querySelector('h3')?.textContent.includes(text));
    const intro = panel.querySelector('.togstd-hero');
    intro.classList.add('zf-intro');
    intro.querySelector('h2').textContent = 'Adjustable airflow for your grow tent';
    intro.querySelector('.togstd-eyebrow')?.remove();
    const introParagraph = intro.querySelector('p') || intro.appendChild(document.createElement('p'));
    introParagraph.textContent = 'Keep air moving around your plants with the TheOneGrow 6-inch clip fan. Choose from 10 speed settings and 45° or 90° automatic oscillation to suit your grow tent, then secure the fan to a compatible 15–30mm tent pole. With a maximum rated power of 10W, it provides adjustable air circulation as part of your ventilation setup.';

    const facts = panel.querySelector('.togstd-facts');
    facts.className = 'zf-facts';
    facts.innerHTML = '<div><strong>10 speeds</strong><span>Airflow control</span></div><div><strong>45° / 90°</strong><span>Automatic oscillation</span></div><div><strong>15–30mm</strong><span>Compatible pole diameter</span></div><div><strong>10W max</strong><span>Rated power</span></div>';
    const fit = findSection('Where This Product Fits Best');
    if (fit) {
      const copy = make('div', 'zf-copy'); while (fit.firstChild) copy.append(fit.firstChild);
      fit.classList.add('zf-fit'); fit.append(copy, picture(0, 'TheOneGrow 6-inch clip fan for grow tent air circulation')); facts.after(fit);
    }
    const advantages = panel.querySelector('.togstd-original-advantages');
    if (advantages) {
      const children = [...advantages.children];
      const list = make('div', 'zf-feature-list'); let article;
      children.forEach(el => {
        if (el.tagName === 'H3') return;
        if (el.tagName === 'P' && /^\d+\.\s/.test(el.textContent.trim())) {
          article = make('article', 'zf-feature');
          article.append(make('h3', '', el.textContent.trim().replace(/^\d+\.\s*/, '')));
          list.append(article);
        } else if (article) article.append(el);
      });
      const summary = make('div', 'zf-summary', '<h2>Control air movement around your plants</h2><p>Set the airflow, choose an oscillation angle and attach the fan to a compatible tent pole.</p><div class="zf-summary-facts"><span><b>10 speeds</b>Manual adjustment</span><span><b>PWM</b>External control</span></div>');
      advantages.replaceChildren(summary, list); advantages.classList.add('zf-features');
    }
    const specs = findSection('6 Inch Clip Fan Specs');
    if (specs) {
      specs.querySelectorAll('tr').forEach(tr => { if (tr.cells[0]?.textContent.trim() === 'Efficacy') tr.remove(); });
      specs.querySelector('h3').textContent = '6-inch clip fan specifications';
      tabs.querySelector('#togstd-specifications-panel').replaceChildren(specs);
    }
    const comparison = findSection('vs. Other');
    comparison?.classList.add('zf-comparison');
    const guide = findSection('User Guide');
    if (guide) {
      guide.classList.add('zf-guide');
      const copy = make('div', 'zf-guide-copy');
      while (guide.firstChild) copy.append(guide.firstChild);
      const heading = copy.querySelector('h3'); heading.textContent = 'How to use your clip fan';
      const steps = make('ol', 'zf-steps');
      [...copy.querySelectorAll(':scope > p')].forEach(p => {
        const li = document.createElement('li'); li.textContent = p.textContent.trim().replace(/^\d+\.\s*/, '').replace(/\s+/g, ' '); steps.append(li); p.remove();
      });
      copy.append(steps); guide.append(copy, picture(4, 'Clip fan angle and oscillation controls'));
    }
    const box = findSection('What Is Included');
    if (box) { box.classList.add('zf-box'); box.querySelector('h3').textContent = "What's in the box?"; }
    const safety = findSection('Use And Safety'); safety?.classList.add('zf-safety');
    tabs.querySelectorAll('.togstd-tab-nav label').forEach((label, i) => {
      label.textContent = ['Description', 'Specifications', 'FAQ', 'Reviews'][i]; label.tabIndex = 0;
      label.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); label.click(); } });
    });
    panel.classList.add('zf-content');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Keep the existing clip-fan video in gallery position two. */
(() => {
  let attempts = 0;
  function moveVideo() {
    const root = document.querySelector('.js-product-8745937830039');
    const slider = root?.querySelector('.js-product-slider');
    const thumbs = root?.querySelector('.js-product-single-thumbs');
    const frame = root?.querySelector('iframe[src*="youtube.com/embed/cj9jfUguAuo"]');
    const $ = window.jQuery;
    if (!slider || !thumbs || !frame || !$ || !slider.classList.contains('slick-initialized')) {
      if (++attempts < 60) setTimeout(moveVideo, 250);
      return;
    }
    if (root.dataset.videoInGallery) return;
    root.dataset.videoInGallery = 'true';
    const videoId = 'cj9jfUguAuo';
    const thumb = document.createElement('div');
    thumb.innerHTML = '<img class="product-single__photo-thumbs__img" src="https://i.ytimg.com/vi/'+videoId+'/hqdefault.jpg" alt="Play clip fan video" width="60" height="60"><span class="zf-video-play" aria-hidden="true">▶</span>';
    thumb.className = 'zf-video-thumb';
    thumbs.children[0].after(thumb);
    const slide = document.createElement('div');
    slide.className = 'product-single__photo__wrapper zf-gallery-video';
    slide.innerHTML = '<div class="zf-video-stage"></div>';
    const previousParent = frame.parentElement;
    const previousWrapper = previousParent.classList.contains('fluid-width-video-wrapper') ? previousParent : null;
    const src = new URL(frame.src);
    src.searchParams.set('enablejsapi', '1');
    src.searchParams.set('origin', location.origin);
    frame.src = src.href;
    frame.title = 'TheOneGrow 6-inch clip fan demonstration';
    frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    frame.setAttribute('allowfullscreen', '');
    slide.firstElementChild.append(frame);
    previousWrapper?.remove();
    if (previousParent.tagName === 'P' && !previousParent.children.length) previousParent.remove();
    $(slider).slick('slickAdd', slide, 0, false);
    $(slider).on('beforeChange.zaClipVideo', function(event, slick, current, next) {
      if (current === 1 && next !== 1) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), 'https://www.youtube.com');
    });
    $(slider).slick('slickGoTo', 0, true);
    $(slider).slick('setPosition');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveVideo); else moveVideo();
})();
